<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-06-08 10:30:07
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-11 16:32:25
 * @FilePath: \Lightingxj\src\views\set\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="setContainer">
    <div class="sidebar">
      <div
        class="sidebarItem"
        :class="{ active: activeMenu === 'userManage' }"
        @click="menuChange('userManage')"
      >人员管理</div>
      <div
        class="sidebarItem"
        :class="{ active: activeMenu === 'modifyLog' }"
        @click="menuChange('modifyLog')"
      >修改记录</div>
      <div
        class="sidebarItem"
        :class="{ active: activeMenu === 'deviceManage' }"
        @click="menuChange('deviceManage')"
      >电场仪管理</div>
    </div>
    <div class="setContent">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeMenu: 'userManage'
    };
  },
  created() {
    this.syncActiveMenu();
  },
  watch: {
    $route() {
      this.syncActiveMenu();
    }
  },
  methods: {
    syncActiveMenu() {
      const name = this.$route.name;
       this.activeMenu = name;
     
    },
    menuChange(menu) {
      this.$router.push('/set/' + menu);
      // if (menu === 'modifyLog') {
      //   this.$router.push('/set/modifyLog');
      // } else {
      //   this.$router.push('/set/userManage');
      // }
    }
  }
};
</script>

<style scoped>
.setContainer {
  display: flex;
  height: 100%;
}
.sidebar {
  width: 180px;
  background: #001a33;
  padding-top: 20px;
  flex-shrink: 0;
}
.sidebarItem {
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: #b0c4de;
  cursor: pointer;
  font-size: 15px;
  transition: all 0.3s;
}
.sidebarItem:hover {
  background: #00284d;
  color: #fff;
}
.sidebarItem.active {
  background: #003d6b;
  color: #00c8ff;
  border-right: 3px solid #00c8ff;
}
.setContent {
  flex: 1;
  overflow: auto;
}
</style>
